import * as React from 'react'
import { ReactElement } from 'react'
import { ActionButton } from '@fluentui/react'
import useSubmitDocumentGenerationRequest from '../../hooks/finance/report/useSubmitDocumentGenerationRequest'
import { DocumentGenerationType } from '../../hooks/document/useDocumentGenerationHandler'
import { useTranslation } from 'react-i18next'

type Props<ParamsT> = {
    generationType: DocumentGenerationType
    payload: () => Omit<ParamsT, 'generationType'>
    labelKey?: string
}

export default function CsvReportButton<ParamsT>(props: Props<ParamsT>): ReactElement {
    const submitReportRequest = useSubmitDocumentGenerationRequest<ParamsT>(props.generationType)
    const { t: translate } = useTranslation()

    return (
        <ActionButton
            iconProps={{ iconName: 'Download' }}
            onClick={() => {
                submitReportRequest(props.payload())
            }}
        >
            {translate(props.labelKey ?? 'action.download.selection')}
        </ActionButton>
    )
}
